import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=4ed20d1c&scoped=true"
import script from "./GroupHeader.vue?vue&type=script&lang=js"
export * from "./GroupHeader.vue?vue&type=script&lang=js"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=4ed20d1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed20d1c",
  null
  
)

export default component.exports